import TAP1 from '@/assets/tap1.png';
import TAP2 from '@/assets/tap2.png';
import TAP3 from '@/assets/tap3.png';

export const CARD_STYLES = {
  tap1: {
    img: TAP1,
    subtitleBg: 'bg-[#EEF0DF]',
    textAndCupColor: 'text-[#4F4F4F]',
    cupBg: 'bg-[#FEF6BD]',
    buttonColor: 'bg-[#4F4F4F]',
  },
  tap2: {
    img: TAP3,
    subtitleBg: 'bg-[#F2F2F2]',
    textAndCupColor: 'text-[#1B276A]',
    cupBg: 'bg-[#F2F2F2]',
    buttonColor: 'bg-[#9535AE]',
  },
  tap3: {
    img: TAP2,
    subtitleBg: 'bg-[#E3EAFF]',
    textAndCupColor: 'text-[#3399FE]',
    cupBg: 'bg-[#E3EAFF]',
    buttonColor: 'bg-[#3399FE]',
  },
};
